// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"eb2d9bdc","453":"6264690d"}[chunkId] + ".chunk.js";
};